import AppLayout from "../components/common/AppLayout";

export default function AuditoriaPage() {
    return (
        <AppLayout title="Auditoría">
            <div className="card-panel">
                <h3>Bitácora de auditoría</h3>
                <p>Aquí irá el historial de cambios: inserciones, ediciones, anulaciones, inicios de sesión y eventos sensibles.</p>
            </div>
        </AppLayout>
    );
}